import React from 'react';
import autoBind from 'react-autobind';
import { withRouter } from 'react-router';
import NavigationBar from './NavigationBar.jsx';
import RouteConstants from '../constants/RouteConstants.js';
import ElectronicSubmissionStore from '../stores/ElectronicSubmissionStore.js';
import ApplicationStore from '../stores/ApplicationStore';
import ContentService from '../services/ContentService.js';
import Transitions from '../core/Transitions.js';
import Formatter from '../utils/Formatter.js';
import ApplicationActions from '../actions/ApplicationActions.js';
import Footer from './Footer.jsx';
import FooterUtil from './../utils/FooterHelper';
import DownloadFormsHelper from '../utils/DownloadFormsHelper.js';
import ApplicationHelper from '../utils/ApplicationHelper.js';
import OmnitureTracking from '../utils/OmnitureTracking.js';
import DeclarationStore from '../stores/DeclarationStore.js';

function getStateFromStore() {
    return {
        product: ElectronicSubmissionStore.getProduct(),
        content: ContentService.getContent(),
        showMoreMenu: ElectronicSubmissionStore.getShowHideMore(),
        electronicSubmissionData: ElectronicSubmissionStore.getElectronicSubmissionData(),
        isJoint: ElectronicSubmissionStore.getIsJoint(),
        mobileNumbers: ElectronicSubmissionStore.getMobileNumbers(),
        applicationId: ElectronicSubmissionStore.getApplicationId(),
        formModel: ElectronicSubmissionStore.getFormModel(),
        consolidatedFormModel: ElectronicSubmissionStore.getConsolidatedFormModel(),
        accountNumber: ElectronicSubmissionStore.getAccountNumber(),
        hasSubmitFailed: ElectronicSubmissionStore.getHasSubmitFailed(),
        isApplicationSubmitting: DeclarationStore.getApplicationSubmitting(),
        showDownloadMenu: ElectronicSubmissionStore.getShowDownloadMenu(),
        formsToDownload: ElectronicSubmissionStore.getFormsToDownload(),
        enableDownloadButton: ElectronicSubmissionStore.getEnableDownloadButton(),
        accountType: ElectronicSubmissionStore.getAccountType(),
        downloadInProgress: ElectronicSubmissionStore.getDownloadInProgress(),
        selectedForms: ElectronicSubmissionStore.getSelectedForms(),
        readyForDownload: ElectronicSubmissionStore.getReadyForDownload(),
        downloadedForms: ElectronicSubmissionStore.getDownloadedForms(),
        formDownloaded:ElectronicSubmissionStore.getIsFormsDownloaded(),
        downloadFormsFailed: ElectronicSubmissionStore.getDownloadFormsFailed(),
        clientIdentificationMode: ApplicationStore.getClientIdentificationMode()
    };
}

class ElectronicSubmission extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getStateFromStore();
    }

    componentDidMount() {
        ElectronicSubmissionStore.addChangeListener(this._onChange);
        DeclarationStore.addChangeListener(this._onChange);
        OmnitureTracking.getTrackingEnabled();
    }

    componentWillUnmount() {
        ElectronicSubmissionStore.removeChangeListener(this._onChange);
        DeclarationStore.removeChangeListener(this._onChange);
    }

    _onChange() {
        this.setState(getStateFromStore());
    }

    validate() {
        Transitions.forwardFromElectronicSubmission(this.props.router, { valid: true });
    }

    print() {
        if (!this.state.accountNumber) {
            const applicationForSubmit = ApplicationHelper.getApplicationWithoutPredictiveSearchAdviceFee(this.state.formModel);            
            ApplicationActions.submitApplication(this.state.product.value, applicationForSubmit, this.state.consolidatedFormModel.form.investmentAllocation.investmentOptions);
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (!this.state.accountNumber && nextState.accountNumber){
            Transitions.forwardFromElectronicSubmission(this.props.router, { valid: false });
        }
    }

    render() {
        let contentCopy = this.state.isJoint
            ? this.state.content.electronicSubmission.jointCopy
            : this.state.content.electronicSubmission.individualCopy;
        const electronicSubmissionCopy = Formatter.formatString(contentCopy, { mobile: this.state.electronicSubmissionData.mobileNumber });
        const electronicSubmissionName = Formatter.formatString(this.state.content.electronicSubmission.header, { name: this.state.electronicSubmissionData.applicantName, productName: this.state.product.label });
        const noMobilePhoneCopy = Formatter.formatString(this.state.content.electronicSubmission.noMobilePhoneCopy, { productName: this.state.product.label });
        const footerContent = FooterUtil.getContent(this.state.product.value, this.state.content.footer);
        const dockFooterStyle = FooterUtil.adjustViewport();
        const downloadData = DownloadFormsHelper.createDownloadData(this.state);

        return (
            <div className="electronic-submission-page">
                <div id="electronic-submission" className="electronic-submission-page__mainContent" style={dockFooterStyle}>
                    <NavigationBar
                        product={this.state.product} 
                        route={RouteConstants.ElectronicSubmission} 
                        moreMenuContent={this.state.content.moreMenu} 
                        showMoreMenu={this.state.showMoreMenu} 
                        application={this.state.formModel}
                        clientIdentificationMode={this.state.clientIdentificationMode}
                        showDownloadMenu={this.state.showDownloadMenu}
                        accountType={this.state.accountType}
                        download={downloadData}/>
                    <nav className="navbar-sub-sectionName navbar navbar-sub">
                        <div className="container">
                            <div className="pull-left">
                                <span className="heading-text">{this.state.content.electronicSubmission.pageTitle}</span>
                            </div>
                        </div>
                    </nav>
                    <div className="electronic-submission-container">
                        <div className="electronic-submission-section">
                            <label>{electronicSubmissionName}</label>
                            <div dangerouslySetInnerHTML={{ __html: electronicSubmissionCopy }}></div>
                            <button id="continueToValidation" className="btn btn-success btn-lg" disabled={this.state.isApplicationSubmitting} onClick={this.validate}>Continue to validation?
                                <i className="icon icon-right-open-big"></i>
                            </button>
                        </div>
                        <div className="electronic-submission-section">
                            <label>{this.state.content.electronicSubmission.noMobilePhoneLink}</label>
                            <div dangerouslySetInnerHTML={{ __html: noMobilePhoneCopy }}></div>
                            <button type="button"
                                    className="btn btn-info btn-lg"
                                    id="electronic-submission-print-btn"
                                    disabled={this.state.isApplicationSubmitting}
                                    onClick={this.print}>Print application and obtain account number
                                <i className="icon icon-print"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <Footer content={footerContent} />
            </div>);
    }
}

export default withRouter(ElectronicSubmission)


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ElectronicSubmission.jsx